import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const BreadcrumbLinkStyled = styled.a`
  color: ${({ theme }) => theme.colors.inkMuted};
  font-size: ${pxToRem(20)};
  font-weight: 400;
  line-height: 1.4;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.brand};
  }
`;
